import { Pipe, PipeTransform } from '@angular/core';
import { FuseUtils } from '@fuse/utils';

@Pipe({
  name: 'maxLength'
})
export class MaxLengthPipe implements PipeTransform {
  transform(value, length): string {
    return value.length > length ? FuseUtils.stringTruncade({ value, length }) : value;
  }
}
